import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapCheckBox = React.lazy(function () {
    return import('../../bootstrap-components/components/BTCheckBox');
});
var bootStrapCheckBox = function (props) {
    return (React.createElement(BootStrapCheckBox, { onChange: props.onChange, onBlur: props.onBlur, label: props.label, children: props.children, cssModule: props.cssModule, options: props.options, mandatory: props.mandatory, hasError: props.hasError, errorMessage: props.errorMessage, style: {}, styleName: props.styleName, ioTheme: props.ioTheme, ioMode: props.ioMode, displayType: props.displayType, disabled: props.disabled, configId: props.configId, name: props.name, value: props.value, checked: props.checked }));
};
export var CheckBox = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapCheckBox(props);
        default:
            componentToDisplay = bootStrapCheckBox(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
CheckBox.defaultProps = {
    label: 'Degree: ',
    mandatory: false,
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
//# sourceMappingURL=CheckBox.js.map